<template>
    <div v-if="!loading && !!ifConditionIsValid" :class="customClass">
        <slot name="ifcategory" />
    </div>
</template>

<script>

    export default {

        props: {
            conditionType: { type: String, default: '' },
            customClass: { type: String, default: '' },
            listCategories: { type: String, default: '' },
        },

        computed: {

            ifConditionIsValid () {
              let res=false;
              if(this.conditionType === 'is-in') {
                res = (this.intersect(this.listOfCategories, this.categoriesRecovered).length>0);
              }else if(this.conditionType === 'is-not-in'){
                res = !(this.intersect(this.listOfCategories, this.categoriesRecovered).length>0);
              }
              /*
              if(res){
                console.log("ConditionIsValid");
              }else{
                console.log("ConditionIsNotValid");
              }
              */
              return res;
            },

            currentCategory () {
                // console.log("--******************* currentCategory for Variation: "+JSON.stringify(this.$store.getters.currentItemVariation.defaultCategories[0].id));
                return this.$store.getters.currentItemVariation.defaultCategories[0].id;

            },

            currentCategories () {
              return this.categoriesRecovered;
            },

          currentVariation () {
            // console.log("--******************* currentVariationID: "+this.$store.getters.currentItemVariation.variation.id);
            return this.$store.getters.currentItemVariation.variation.id;

          },

          listOfCategories () {
                const listT = this.listCategories.replace(/ /g, '');
                const listFinalTempo = listT.split(',');
                const listFinal = listFinalTempo.map((i) => Number(i));

                return listFinal;
            }
        },

      watch: {
        currentVariation:
            {
              handler(val, oldVal)
              {
                // console.log("ChangeVariationID");

                $.ajax({
                  data: {"variationId": this.currentVariation},
                  type: "GET",
                  dataType: "json",
                  url:  "/ifs/getCategoriesLinked"
                }).done(( res ) => {
                  // console.log("Result: "+JSON.stringify(res.data));
                  this.categoriesRecovered = res.data;
                  this.loading = false;
                }).fail(( err ) => {
                  // console.log("Error GETTING: "+JSON.stringify(err));
                  this.categoriesRecovered = [];
                  this.loading = false;
                });

                // console.log("After AJAX-Update List of Categories");
              },
              deep: true
            }
      },

      created () {
            this.endpoint = `ifs/getCategoriesLinked?variationId=${this.currentVariation}`;
      },

      mounted () {
        $.ajax({
          data: {"variationId": this.currentVariation},
          type: "GET",
          dataType: "json",
          url:  "/ifs/getCategoriesLinked"
        }).done(( res ) => {
          // console.log("Result: "+JSON.stringify(res.data));
          this.categoriesRecovered = res.data;
          this.loading = false;
        }).fail(( err ) => {
          // console.log("Error GETTING: "+JSON.stringify(err));
          this.categoriesRecovered = [];
          this.loading = false;
        });

      },
      methods: {
        intersect(listA, listB){
          // console.log("intersect, A: ",listA, ", B: ",listB);
          let i,x;
          let res=[];

          for(i=0;i<listA.length;i++){
            x = listA[i];
            if(listB.includes(x)){
              res.push(x);
            }
          }

          // console.log("len intersect: "+res.length);
          return res;
        }

      },

        data(){
            return{
                loading: true,
                endpoint: '',
                categoriesRecovered: []
            }
        }
    }
</script>
